import React from 'react';
import {Button, Card, CardBody, Col, Row} from 'reactstrap';
import "react-internet-meter/dist/index.css";
// import label from "../message/Label"
import label from 'enqc-utilities/src/label/Label'
import SockJsClient from "react-stomp";
import Global from "../utils/Global";
import {isSuccess} from "../utils/Utilities";
import BasePage from "./BasePage";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";

class TokenPage extends BasePage {
    clientTokenRef ;

    constructor(props) {
        super(props);
        let state = this.state
        state.token = {}
        state.netSpeed = 0
        this.setState(state)
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchToken()
    }

    async fetchToken(){
        let response = await this.asyncGet(Global.API.GET_LATEST_TOKEN, null, null, true, true);
        if(isSuccess(response)){
            let token = response.data
            this.setState({token})
        }
    }
    async refreshToken(){
        let response = await this.asyncGet(Global.API.REFRESH_TOKEN, null, null, true, true);
        if(isSuccess(response)){
            let token = response.data
            this.setState({token})
        }
    }


    render() {
        let {token} = this.state
        return (
            <span>
            {super.render()}
            <Row
                style={{
                    height: '130vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <Col md={6} lg={4}>
                    <Card style={{textAlignment:'center'}}>
                        <PrimaryCardHeader
                            style={{textAlign:'center'}}
                            content={(
                                <h2>{label.TokenCode}</h2>
                            )}/>
                        <CardBody style={{textAlign:'center'}}>
                            <Row>
                                <Col>
                                    <h1 style={{fontSize:'5rem', letterSpacing:'10px', color:"green", fontWeight:"bold"}}>{token.code}</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>
                                        {label.TokenDescription}
                                    </p>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col>
                                    {label.TimeExpired}<br/><font style={{fontSize:'3rem', color:"red"}}>{token.secondRemaining}</font>s
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                            <Button
                                className="btn-main"
                                color={"none"}
                                size="lg"
                                block
                                onClick={()=>{
                                    this.refreshToken()
                                }}>
                                {label.Refresh}
                            </Button>
                                </Col>
                            </Row>
                        </CardBody>

                    </Card>
                </Col>
            </Row>
                  <SockJsClient
                      url={Global.BASE_URL}
                      topics={[Global.API.LISTEN_UPDATE_TOKEN]}
                      getRetryInterval={()=>300000}
                      heartbeat={1000}
                      autoReconnect={false}
                      onMessage={(message) => {
                          console.log(message)
                          this.setState({token:message})
                      }}
                      ref={ (client) => { this.clientTokenRef = client }} />
            </span>

        );
    }
}

export default Object.assign(TokenPage, {ENDPOINT : "/token"})
